import React from 'react';
import { FaRegIdBadge, FaSearch } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import RightNav from '../components/RightNav';
import { primaryNavigation } from './navigation';

export default function AppShell({ children, hideNav, user, onVoucherLookupOpen, overlay }) {
  const location = useLocation();

  if (hideNav) {
    return <>{children}</>;
  }

  return (
    <div className="app-shell">
      <header className="app-topbar">
        <Link to="/dashboard" className="brand-link">
          <span className="brand-mark">
            <FaRegIdBadge />
          </span>
          <span className="brand-text">Voucher Portal</span>
        </Link>

        <nav className="app-nav" aria-label="Primary">
          {primaryNavigation.map(({ to, label, icon: Icon, matchPaths }) => {
            const selected = matchPaths
              ? matchPaths.some(
                  (p) => location.pathname === p || location.pathname.startsWith(`${p}/`)
                )
              : location.pathname.startsWith(to);
            return (
              <Link key={to} to={to} className={selected ? 'app-nav-item selected' : 'app-nav-item'}>
                <Icon />
                <span>{label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="app-topbar-actions">
          <button
            type="button"
            className="quick-action-btn voucher-lookup-btn"
            title="Voucher lookup — Ctrl+K or ⌘K"
            aria-haspopup="dialog"
            aria-keyshortcuts="Control+K Meta+K"
            onClick={onVoucherLookupOpen}
          >
            <FaSearch />
            <span>Lookup</span>
          </button>
          <RightNav user={user} isAdmin={user?.isAdmin} />
        </div>
      </header>

      <main className="app-content">
        <div className="app-content-scroll">
          <div className="app-route-outlet">{children}</div>
        </div>
      </main>
      {overlay ?? null}
    </div>
  );
}
